export default __webpack_public_path__ + "static/media/cookies.48c05729.svg";